import React from "react";
import { useMediaQuery } from "@react-hook/media-query";

//components
import {
	Text,
	Grid,
	Col,
	CloudinaryImage,
	PricingAccordion,
} from "@website-builder/ui/shared/elements";

import { DESKTOP_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

//styles
import { PricingWrapper, ChartCardWrapper } from "./styles";

const PricingWR = (props) => {
	//props
	const {
		label,
		headline,
		description,
		pricingOptions,
		pricingWRCard,
		pageSection,
	} = props;
	const isB2u = process.env.GATSBY_BUSINESS_VERTICAL === "b2u";

	//media query
	const isDesktopWidth1200 = useMediaQuery(`(max-width:${DESKTOP_M_BP}px)`);

	const ChartCard = () => {
		return (
			<Col
				start={pricingOptions ? (isDesktopWidth1200 ? 8 : 9) : 1}
				span={isDesktopWidth1200 ? 5 : 4}
				mdSpan={6}
			>
				<ChartCardWrapper>
					<Text
						variant="headline_6"
						tag="h3"
						color={{
							base: "primary",
							color: "neutral-nightshade",
							shade: "800",
						}}
					>
						{pricingWRCard?.headline}
					</Text>
					<Text
						variant="paragraph_M"
						color={{
							base: "primary",
							color: "neutral-nightshade",
							shade: "600",
						}}
						tag="div"
						dangerouslySetInnerHTML={{ __html: pricingWRCard?.description }}
					/>

					{pricingWRCard?.media && (
						<CloudinaryImage
							className="card-image"
							alt={pricingWRCard?.media?.image?.altTag}
							url={pricingWRCard?.media?.image?.image}
							quality="auto"
							lazyload
							fetchFormat="auto"
						/>
					)}

					<Text
						variant="paragraph_S"
						color={{
							base: "secondary",
							color: "gray",
							shade: "dark",
						}}
					>
						{pricingWRCard?.footerText}
					</Text>
				</ChartCardWrapper>
			</Col>
		);
	};

	return (
		<PricingWrapper className="pricing-comparison">
			<Grid>
				<Col start={2} span={10} mdSpan={6}>
					<Grid hMargin={[0, 0]}>
						<Col
							start={isB2u ? (pricingWRCard ? 1 : 3) : null}
							span={isB2u ? (pricingWRCard ? 10 : 8) : 10}
							mdSpan={6}
						>
							<div className="pricing-heading-wrapper">
								{label ? (
									<Text
										variant="label_M"
										color={{
											base: "secondary",
											color: "gray",
											shade: "dark",
										}}
									>
										{label}
									</Text>
								) : null}
								{headline ? (
									<Text
										variant="headline_3"
										tag="h2"
										color={{
											base: "primary",
											color: "neutral-nightshade",
											shade: "800",
										}}
									>
										{headline}
									</Text>
								) : null}
								{description ? (
									<Text
										variant="paragraph_M"
										color={{
											base: "primary",
											color: "neutral-nightshade",
											shade: "600",
										}}
										tag="div"
									>
										<div
											className="pricing-description"
											dangerouslySetInnerHTML={{ __html: description }}
										></div>
									</Text>
								) : null}
							</div>
						</Col>
					</Grid>

					{pricingOptions || pricingWRCard ? (
						<Grid hMargin={[0, 0]} className="accordion-pricing-grid">
							{pricingOptions ? (
								<Col
									start={isB2u ? (pricingWRCard ? 1 : 3) : null}
									span={pricingWRCard ? 7 : isB2u ? 8 : 9}
									mdSpan={6}
								>
									<PricingAccordion
										options={pricingOptions}
										pageSection={pageSection}
									/>
								</Col>
							) : null}
							{pricingWRCard && <ChartCard />}
						</Grid>
					) : null}
				</Col>
			</Grid>
		</PricingWrapper>
	);
};

export default PricingWR;
